module.exports = __webpack_public_path__ + "img/9788993174182.f4e704fc.jpg";